import { render, staticRenderFns } from "./mj-image.vue?vue&type=template&id=0bde3cbe&scoped=true"
import script from "./mj-image.vue?vue&type=script&lang=ts"
export * from "./mj-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde3cbe",
  null
  
)

export default component.exports